import { SagaIterator } from "redux-saga";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { selectUserCidpId } from "scenes/selectors";
import factory from "utils/getApiHandlerEffect";
import {
  afterAuthenticatorsLoaded,
  afterPasskeysLoaded,
  fetchPasskeys,
  loadAuthenticators,
  deletePasskey,
  afterPasskeyDeleted,
} from "./redux";

export function* onLoad(): SagaIterator {
  const cidpId = yield select(selectUserCidpId);
  const apiHandler: APIHandler = yield call(() => factory());
  try {
    const response = yield call(() => apiHandler.getUserAuthenticators(cidpId));
    yield put(afterAuthenticatorsLoaded(response));
  } catch (e: any) {
    // yield setError(true);
  }
}

export function* onLoadPasskeys(): SagaIterator {
  const cidpId = yield select(selectUserCidpId);
  const apiHandler: APIHandler = yield call(() => factory());
  try {
    const response = yield call(() => apiHandler.getPasskeys(cidpId));
    yield put(afterPasskeysLoaded(response));
  } catch (e: any) {
    // yield setError(true);
  }
}

export function* onDeletePasskey(
  action: ReturnType<typeof deletePasskey>
): SagaIterator {
  const cidpId = yield select(selectUserCidpId);
  const apiHandler: APIHandler = yield call(() => factory());
  try {
    yield call(() =>
      apiHandler.deletePasskey(action.payload.credentialId, cidpId)
    );
    yield put(
      afterPasskeyDeleted({ credentialId: action.payload.credentialId })
    );
  } catch (e: any) {
    // yield setError(true);
  }
}

// watcher function
export default function* dashboardSecuritySettingsSaga() {
  yield takeLatest(loadAuthenticators.type, onLoad);
  yield takeLatest(fetchPasskeys.type, onLoadPasskeys);
  yield takeLatest(deletePasskey.type, onDeletePasskey);
}
